import {useState,useEffect,useRef} from 'react'
import { useConfig } from '../../contexts/ConfigContext';
import { FileSearch } from './components/FileSearch'
import { Medium} from './components/Medium'
import {MarkModal} from '../../components/MarkModal'
import useGetSavedFoldList from '../../hooks/useGetSavedFoldList';
import useGetPdf from '@hooks/useGetPdf'
import {FileContentModal} from './components/FileContentModal'
import { SearchInput} from './components/SearchInput'
import useCreateSearchFast from '../../hooks/useCreateSearchFast';
import { useLocation,useSearchParams,useNavigate} from 'react-router-dom';
import {FullScreenMindTreeModal} from '@components/FullScreenMindTreeModal';
import { FastCompareFiles } from './components/FastCompareFiles';
import { PolicyTrend } from './components/PolicyTrend';
import { ScrolltoTopBtn } from '@components/ScrolltoTopBtn';
import { Home,Star,MessageSquare,ChevronsRight, Layers, FileText, Bookmark, Search as SearchIcon, Zap, Award, Star as StarIcon, Grid } from 'react-feather';
import util from '../../utils/utils';
import { POLICY_EMPTY_FILTERED_TAGS } from '@constants';

export const PolicySearchPage = (props) => {
    const { clientId } = useConfig();
    const [searchParams] = useSearchParams();
    const [selectedCards,setSelectedCards] =useState([])
    const [collapsed,setCollapsed] = useState(true)
    const [input,setInput] =useState('')
    const [tab,setTab] = useState(searchParams.get('k') ? 'pure_policy' : '')
    // const [select3, setSelect3] = useState(false)
    const [markData, setMarkData] = useState()
    const {savedFoldListLoading, savedFoldListData, savedFoldListRefresh} = useGetSavedFoldList()
    const {getPdfLoading,getPdfAction} = useGetPdf()
    const [medium,setMedium] = useState('qa')
    const [fileName, setFileName] = useState()
    const [fileId, setFileId] = useState()
    const [mdTxt,setMdTxt] =useState('')
    const [prevSearchK, setPrevSearchK] = useState('')
    const prevSearchIndexRef = useRef('')
    const isSearchChanged = useRef(false)
    const { loading,data ,refresh,setQuery,statisticsData,allData,
        setSearched,searched,setDisplayQuery,typeFilter,timeFilter,order,queryArgs} 
    = useCreateSearchFast({
        manual:false,
        onSearchComplete: () => {
            // Scroll to main section when search completes
            setTimeout(() => {
                const mainSection = document.getElementById('main-section');
                if (mainSection) {
                    const headerHeight = document.querySelector('.sticky.top-0')?.offsetHeight || 0;
                    const elementTop = mainSection.offsetTop - headerHeight - 20;
                    window.scrollTo({
                        top: Math.max(0, elementTop),
                        behavior: 'smooth'
                    });
                    setCurrentSection('main');
                }
            }, 100);
        }
    });

    const [searchK,setSearchK] = useState('')
    const [searchOrg,setSearchOrg] = useState('')
    const [stateGridRelated,setStateGridRelated] = useState(true)
    const iframeRef = useRef();
    const IFRAME_ID = 'myQAIframeDivV5'
    const [showQa,setShowQa] = useState(util.getStorage(process.env.REACT_APP_QA_VISIBLE_LOCALSTORAGE_NAME) ?? true)
    

    const [currentSection, setCurrentSection] = useState('top') // Add section tracking

    // 确保在搜索开始时就将 currentSection 设置为 main
    useEffect(() => {
        if (loading && searchK) {
            setCurrentSection('main');
        }
    }, [loading, searchK]);

    // 当搜索关键词变化时，确保 currentSection 为 main
    useEffect(() => {
        if (searchK && searchK !== prevSearchK) {
            setCurrentSection('main');
        }
    }, [searchK, prevSearchK]);
    

    


    const empty_tags = POLICY_EMPTY_FILTERED_TAGS

    useEffect(()=>{
        if(searchK || searchOrg){
            navigate(`/policy/search?k=${searchK}&org=${searchOrg}`)
        }
        if (searchK !== prevSearchK) {
            setPrevSearchK(searchK)
        }
    },[searchK, searchOrg, prevSearchK])

    useEffect(()=>{
        let k = ''
        let org = ''
        let stateGridRelatedFromUrl = false
        
        if(searchParams.get('k')){
            k = searchParams.get('k')
            setSearchK(k)
            setInput(k)
            // 如果有搜索关键词，设置 currentSection 为 main
            setCurrentSection('main')
            // 只有在tab为空时才设置默认值，避免覆盖用户的选择
            if (!tab) {
                setTab('pure_policy')
            }
        }
        
        // 如果只有政策来源没有搜索关键词，也设置默认tab
        if(searchParams.get('org') && !searchParams.get('k') && !tab){
            setTab('pure_policy')
        }
        
        // 读取URL参数中的state_grid_related值
        if(searchParams.get('state_grid_related')){
            stateGridRelatedFromUrl = searchParams.get('state_grid_related') === 'true'
            setStateGridRelated(stateGridRelatedFromUrl)
        }
        
        // 如果有搜索关键词，设置默认机构筛选条件
        let _tags = {...empty_tags}
        if(searchParams.get('org')){
            org = searchParams.get('org')
            
            // 使用映射表获取完整的层级路径
            let provincePath;
            if(org === '发改委'){
                provincePath = '国务院/国家发展和改革委员会'
            } else if(org === '能源局'){
                provincePath = '国务院/国家发展和改革委员会/国家能源局'
            } else if(org === '工信部'){
                provincePath = '国务院/工业和信息化部'
            } else if(org === '国资委'){
                provincePath = '国务院/国务院国有资产监督管理委员会'
            } else if(org === '财政部'){
                provincePath = '国务院/财政部'
            } else if(org === '国务院'){
                provincePath = '国务院'
            } else {
                provincePath = org
            }
            
            _tags.province_list = [provincePath]
        } else if(k) {
            // 如果有搜索关键词但没有指定机构，不设置默认机构筛选，让用户自由选择
            // _tags.province_list = ['国务院', '国务院/国家能源局', '国务院/国家发展和改革委员会']
        }

        // 根据当前tab设置默认的large_policy_class_list
        if (k || searchParams.get('org')) {
            // 如果没有tab或tab为空，默认使用pure_policy
            const currentTab = tab || 'pure_policy';
            if (currentTab === 'pure_policy') {
                _tags.large_policy_class_list = ['政策文件', '政策法规', '规章制度', '公示公告', '行业政策'];
            } else if (currentTab === 'interpretation') {
                _tags.large_policy_class_list = ['政策解读'];
            } else if (currentTab === 'important_speech') {
                _tags.large_policy_class_list = ['重要讲话'];
            }
        }
        
        
        setQuery({
            search_content:k,
            filter_tags:_tags,
            state_grid_related:stateGridRelatedFromUrl
        })
    },[searchParams, tab, stateGridRelated])

    // 移除自动切换tab的逻辑，让用户自由选择

    // Track search keyword changes
    useEffect(() => {
        if (searchK !== prevSearchK) {
            isSearchChanged.current = true
            setPrevSearchK(searchK)
        }
    }, [searchK, prevSearchK])

    // Track search index changes
    useEffect(() => {
        if (allData?.search_index && allData.search_index !== prevSearchIndexRef.current) {
            prevSearchIndexRef.current = allData.search_index
            isSearchChanged.current = false
        }
    }, [allData?.search_index])

    const navigate = useNavigate();

    // Function to scroll to different sections
    const scrollToSection = (sectionId) => {
        const targetId = 'main-section';
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            const headerHeight = document.querySelector('.sticky.top-0')?.offsetHeight || 0;
            const elementTop = targetElement.offsetTop - headerHeight - 20;
            
            window.scrollTo({
                top: Math.max(0, elementTop),
                behavior: 'smooth'
            });
            
            // Update current section
            setCurrentSection('main');
        }
    };

    return (
        <>
            <MarkModal
                markData={markData}
                loading={savedFoldListLoading}
                data={savedFoldListData}
                savedFoldListRefresh={savedFoldListRefresh}
            />
            <FullScreenMindTreeModal
                fileName={fileName}
                txt={mdTxt}
                setFileName={setFileName}
                setMdTxt={setMdTxt}            
            />
            <FileContentModal
                getPdfAction={getPdfAction}
                fileName={fileName}
                searchContent={input}
                fileId={fileId}
                savedFoldListData={savedFoldListData}
                setMarkData={setMarkData}
                setFileName={setFileName}
                setMdTxt={setMdTxt}
                highlight
            />
            <div className={`sticky top-0 z-40 flex justify-between mb-5 md:px-4 lg:px-8 2xl:px-12 3xl:px-20 ${searchK ? 'border-b-2 glass' : ''} ${clientId === 'client-b' ? 'bg-transparent backdrop-blur-md' : 'bg-base-100'}`}>
                {/* Fixed width container for tabs to prevent layout shift */}
                <div className="flex" style={{width: '450px', margin: '0 auto'}}>
                    {(searchK || searchParams.get('org')) && (
                        <div className="flex">

                            
                            {/* Policy type tabs - always show when there's search keyword */}
                            <div role="tablist" className="tabs items-end tabs-lg tabs-bordered">
                                <a role="tab"  
                                    className={`${tab === 'pure_policy' ? "tab-active text-primary" : ''} tab h-[4rem] card-title px-4 lg:px-8 cursor-pointer`} 
                                    onClick={()=>{
                                        // 政策文件tab总是可点击
                                        setTab('pure_policy');
                                        // 重新调用搜索接口，使用filter_tags.large_policy_class_list
                                        setQuery({
                                            filter_tags: {
                                                ...queryArgs?.filter_tags,
                                                large_policy_class_list: ['政策文件', '政策法规', '规章制度', '公示公告', '行业政策']
                                            },
                                            search_index: '', // 重置搜索索引，强制重新搜索
                                            page_num: 1 // 重置到第一页
                                        });
                                        // Scroll to main section
                                        setTimeout(() => {
                                            const mainSection = document.getElementById('main-section');
                                            if (mainSection) {
                                                const headerHeight = document.querySelector('.sticky.top-0')?.offsetHeight || 0;
                                                const elementTop = mainSection.offsetTop - headerHeight - 20;
                                                window.scrollTo({
                                                    top: Math.max(0, elementTop),
                                                    behavior: 'smooth'
                                                });
                                                setCurrentSection('main');
                                            }
                                        }, 300);
                                    }}
                                >
                                    <span className="hidden lg:block text-current"><Layers size='1.5rem'/></span>
                                    <span className="text-xl no-translate text-current">政策文件</span>
                                </a>

                                <a role="tab"
                                    className={`${tab === 'interpretation' ? "tab-active text-primary" : ''} tab h-[4rem] card-title px-4 lg:px-8 cursor-pointer`} 
                                    onClick={()=>{
                                        // 政策解读tab总是可点击
                                        setTab('interpretation');
                                        // 重新调用搜索接口，使用filter_tags.large_policy_class_list
                                        setQuery({
                                            filter_tags: {
                                                ...queryArgs?.filter_tags,
                                                large_policy_class_list: ['政策解读']
                                            },
                                            search_index: '', // 重置搜索索引，强制重新搜索
                                            page_num: 1 // 重置到第一页
                                        });
                                        // Scroll to main section
                                        setTimeout(() => {
                                            const mainSection = document.getElementById('main-section');
                                            if (mainSection) {
                                                const headerHeight = document.querySelector('.sticky.top-0')?.offsetHeight || 0;
                                                const elementTop = mainSection.offsetTop - headerHeight - 20;
                                                window.scrollTo({
                                                    top: Math.max(0, elementTop),
                                                    behavior: 'smooth'
                                                });
                                                setCurrentSection('main');
                                            }
                                        }, 300);
                                    }}
                                >
                                    <span className="hidden lg:block text-current"><FileText size='1.5rem'/></span>
                                    <span className="text-xl no-translate text-current">政策解读</span>
                                </a>

                                <a role="tab"
                                    className={`${tab === 'important_speech' ? "tab-active text-primary" : ''} tab h-[4rem] card-title px-4 lg:px-8 cursor-pointer`} 
                                    onClick={()=>{
                                        // 会议讲话tab总是可点击
                                        setTab('important_speech');
                                        // 重新调用搜索接口，使用filter_tags.large_policy_class_list
                                        setQuery({
                                            filter_tags: {
                                                ...queryArgs?.filter_tags,
                                                large_policy_class_list: ['重要讲话']
                                            },
                                            search_index: '', // 重置搜索索引，强制重新搜索
                                            page_num: 1 // 重置到第一页
                                        });
                                        // Scroll to main section
                                        setTimeout(() => {
                                            const mainSection = document.getElementById('main-section');
                                            if (mainSection) {
                                                const headerHeight = document.querySelector('.sticky.top-0')?.offsetHeight || 0;
                                                const elementTop = mainSection.offsetTop - headerHeight - 20;
                                                window.scrollTo({
                                                    top: Math.max(0, elementTop),
                                                    behavior: 'smooth'
                                                });
                                                setCurrentSection('main');
                                            }
                                        }, 300);
                                    }}
                                >
                                    <span className="hidden lg:block text-current"><Bookmark size='1.5rem'/></span>
                                    <span className="text-xl no-translate text-current">会议讲话</span>
                                </a>
                            </div>
                        </div>
                    )}
                </div>
                <div className='hidden lg:block flex-1'>
                    <SearchInput
                        input={input}
                        setInput={setInput}    
                        setSearchK={setSearchK}     
                        setQuery={setQuery}
                        setCurrentSection={setCurrentSection}
                    />  
                </div>
            </div>

            {/* Top area - full width */}
            <div className='w-full px-1 md:px-4 lg:px-6 2xl:px-8 3xl:px-12'>
                <FileSearch
                    input={input}
                    getPdfAction={getPdfAction}
                    getPdfLoading={getPdfLoading}
                    loading={loading}
                    data={data}
                    setQuery={setQuery}
                    setSearched={setSearched}
                    setDisplayQuery={setDisplayQuery}
                    selectedCards={selectedCards}
                    setSelectedCards={setSelectedCards}
                    setMarkData={setMarkData}
                    savedFoldListData={savedFoldListData}
                    fileName={fileName}
                    setFileName={setFileName}
                    setFileId={setFileId}
                    setMdTxt={setMdTxt}
                    allData={allData}
                    stateGridRelated={stateGridRelated}
                    setStateGridRelated={setStateGridRelated}
                    searchK={searchK}
                    filterTags={queryArgs?.filter_tags}
                    queryArgs={queryArgs}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    tab={tab}
                    statisticsData={statisticsData}
                    setSearchOrg={setSearchOrg}
                    currentSection={currentSection}
                    setCurrentSection={setCurrentSection}
                />
            </div>



            {/* Fixed Action Buttons */}
            <div className='fixed bottom-64 right-8'>
                <button className="bg-base-100 group btn hover:btn-primary hover:text-white shadow-lg h-4" 
                    onClick={()=>navigate('/policy')}
                >
                    <Home size='1.5rem'/>
                    <span className='group-hover:block hidden'>回到首页</span>
                </button>
            </div>
            <div className='fixed bottom-48 right-8'>
                <button className="bg-base-100 group btn hover:btn-primary hover:text-white shadow-lg h-4" 
                    onClick={()=>navigate(`/collections?returnUrl=${encodeURIComponent(window.location.href)}`)}
                >
                    <Star size='1.5rem'/>
                    <span className='group-hover:block hidden'>收藏夹</span>
                </button>
            </div>

            <div className='fixed bottom-32 right-8'>
                <PolicyTrend
                    pageSearchK={searchK}
                    loading={loading}
                    data={data}
                    setQuery={setQuery}
                    allData={allData}
                />
            </div>
            <div className='fixed bottom-16 right-8'>
                <ScrolltoTopBtn/>
            </div>

            {/* Mobile Search Input */}
            <div className='fixed bottom-0 flex-col-reverse lg:hidden flex lg:flex-col gap-4 bg-base-100 lg:bg-transparent  w-full z-10  p-4 lg:p-0 border-t'>
                <SearchInput
                    input={input}
                    setInput={setInput}    
                    setSearchK={setSearchK}
                    setCurrentSection={setCurrentSection}
                    large  
                    rounded
                    shadow
                />
            </div>
        </>
    )
}

